import { Flex, Tag, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { ApiService } from "api/api.service";
import TextNumeric from "components/TextNumeric";
import { TbChevronDown, TbChevronUp, TbClipboardCheck, TbCopy, TbFilterFilled, TbMail, TbPhone } from "react-icons/tb";
import { Link } from "react-router-dom";
import { LEAD_STATUS_COLOURS } from "utils/constants";
import { formatDate, formatDateTime, formatMoney } from "utils/functions";

export type PopulatedLeadDto = NonNullable<
  ReturnType<typeof ApiService.lead.useGetAllPaginated>["data"]
>["data"][number];

// function getItemLenth(items: PopulatedQuoteDto["items"]) {
//   return items
//     .map((item) => item.products.length)
//     .reduce((prev, curr) => {
//       return prev + curr;
//     });
// }

const _columns: ColumnsType<PopulatedLeadDto> = [
  // {
  //   key: "invoiceNumber",
  //   dataIndex: "invoiceNumber",
  //   title: "Invoice Number",
  //   render: (val, data) => {
  //     return (
  //       <Typography.Text strong>
  //         <Link to={`/dashboard/chat/${data._id}/${data.messageThread}`}>Quote #{val}</Link>
  //       </Typography.Text>
  //     );
  //   },
  //   sorter: (a, b) => a.invoiceNumber - b.invoiceNumber,
  // },
  {
    key: "name",
    dataIndex: "name",
    title: "Name",
    width: 200,
    fixed: "left",
  },
  {
    key: "email",
    dataIndex: "email",
    title: "Email",
    width: 300,
    render: (_, record) => {
      if (!record.email) {
        return null;
      }
      return (
        <Typography.Text
          type="secondary"
          copyable={{
            text: record.email,
            icon: [<TbCopy key="copy-icon" />, <TbClipboardCheck key="copied-icon" />],
            tooltips: ["Copy", "Copied"],
          }}
          className="flex items-center"
        >
          <TbMail className="mr-2" />
          <small>{record.email}</small>
        </Typography.Text>
      );
    },
  },
  {
    key: "phone",
    dataIndex: "phone",
    title: "Phone",
    width: 160,
    render: (_, record) => {
      if (!record.phone) {
        return null;
      }
      return (
        <Typography.Text
          type="secondary"
          copyable={{
            text: record.phone,
            icon: [<TbCopy key="copy-icon" />, <TbClipboardCheck key="copied-icon" />],
            tooltips: ["Copy", "Copied"],
          }}
          className="flex items-center"
        >
          <TbPhone className="mr-2" />
          <small>{record.phone}</small>
        </Typography.Text>
      );
    },
  },
  // {
  //   key: "message",
  //   dataIndex: "message",
  //   title: "Message",
  //   width: 50,
  //   render: (message: PopulatedQuoteDto["message"]) => {
  //     return (
  //       <>
  //         <Typography.Text ellipsis>{message}</Typography.Text>
  //       </>
  //     );
  //   },
  // },
  // {
  //   key: "remarks",
  //   dataIndex: "remarks",
  //   title: "Remarks",
  //   render: (remarks: PopulatedQuoteDto["remarks"]) => {
  //     return (
  //       <div>
  //         <Typography.Text ellipsis>{remarks?.length ? remarks : "-"}</Typography.Text>
  //       </div>
  //     );
  //   },
  // },
  {
    key: "createdAt",
    dataIndex: "createdAt",
    title: "Created at",
    width: 200,
    render: (createdAt: PopulatedLeadDto["createdAt"]) => {
      return (
        <TextNumeric>
          <Typography.Text type="secondary">
            <small>{createdAt ? formatDateTime(createdAt) : "-"}</small>
          </Typography.Text>
        </TextNumeric>
      );
    },
    // sorter: (a, b) => {
    //   if (a.createdAt && b?.createdAt) {
    //     return dayjs(a.createdAt).diff(b.createdAt);
    //   } else return -1;
    // },
  },
  {
    key: "status",
    dataIndex: "status",
    title: "Status",
    width: 100,
    align: "center",
    render: (status: PopulatedLeadDto["status"]) => {
      return <Tag color={LEAD_STATUS_COLOURS[status]}>{status?.toUpperCase()}</Tag>;
    },
    // filters: Object.entries(LeadStatus).map(([key, value]) => ({
    //   text: <Tag color={LEAD_STATUS_COLOURS[value]}>{key.replace(/_/g, " ")}</Tag>,
    //   value: value,
    // })),
    // onFilter: (value, record) => {
    //   return record.status.indexOf(value as string) === 0;
    // },
  },
  {
    key: "debt_amount",
    dataIndex: "debt_amount",
    title: "Debt Amount",
    width: 120,
    align: "right",
    render: (debt_amount) => {
      return debt_amount ? formatMoney(debt_amount) : "-";
    },
    // sorter: (a, b) => a.debt_amount - b.debt_amount,
  },
  {
    key: "is_making_payments",
    dataIndex: "questionaire",
    title: "Currently Paying",
    width: 160,
    align: "center",
    render: (questionaire: PopulatedLeadDto["questionaire"]) => {
      return <Tag color="default">{questionaire?.is_making_payments?.toUpperCase()}</Tag>;
    },
    // filters: Object.entries(MakingPayments).map(([key, value]) => ({
    //   text: <Tag color={"default"}>{key.replace(/_/g, " ")}</Tag>,
    //   value: value,
    // })),
    // onFilter: (value, record) => {
    //   return record.questionaire?.is_making_payments.indexOf(value as string) === 0;
    // },
  },
  {
    key: "payment_amount",
    dataIndex: "questionaire",
    title: "Payment Amount",
    width: 160,
    align: "right",
    render: (questionaire: PopulatedLeadDto["questionaire"]) => {
      return questionaire?.payment_amount ? formatMoney(questionaire?.payment_amount) : "-";
    },
    // sorter: (a, b) => {
    //   if (typeof a.questionaire?.payment_amount === "number" && typeof b.questionaire?.payment_amount === "number") {
    //     return a.questionaire?.payment_amount - b.questionaire?.payment_amount;
    //   } else {
    //     return -1;
    //   }
    // },
  },
  {
    key: "payment_frequency",
    dataIndex: "questionaire",
    title: "Payment Frequency",
    width: 170,
    align: "center",
    render: (questionaire: PopulatedLeadDto["questionaire"]) => {
      return (
        <TextNumeric>
          <Typography.Text type="secondary">
            <small>{questionaire?.payment_frequency ? formatDate(questionaire?.payment_frequency) : "-"}</small>
          </Typography.Text>
        </TextNumeric>
      );
    },
    // filters: Object.entries(PaymentFrequency).map(([key, value]) => ({
    //   text: <Tag color={"default"}>{key.replace(/_/g, " ")}</Tag>,
    //   value: value,
    // })),
    // onFilter: (value, record) => {
    //   return record.questionaire?.has_pending_lawsuit?.indexOf(value as string) === 0;
    // },
  },
  {
    key: "has_pending_lawsuit",
    dataIndex: "questionaire",
    title: "Has Pending Lawsuit?",
    width: 200,
    align: "center",
    render: (questionaire: PopulatedLeadDto["questionaire"]) => {
      return <Tag color={"default"}>{questionaire?.has_pending_lawsuit?.toUpperCase()}</Tag>;
    },
    // filters: Object.entries(PaymentFrequency).map(([key, value]) => ({
    //   text: <Tag color={"default"}>{key.replace(/_/g, " ")}</Tag>,
    //   value: value,
    // })),
    // onFilter: (value, record) => {
    //   return record.questionaire?.has_pending_lawsuit?.indexOf(value as string) === 0;
    // },
  },

  // {
  //   key: "actions",
  //   title: "",
  //   width: 100,
  //   align: "right",
  //   render: (data: PopulatedQuoteDto) => {
  //     return (
  //       <Space>
  //         <Link to={`/quotation/${data._id}`}>
  //           <Button type="primary">View</Button>
  //         </Link>
  //         {/* <Link to={`/dashboard/chat/${data._id}/${data.messageThread}`}>
  //           <Button type="primary">Chat</Button>
  //         </Link> */}
  //       </Space>
  //     );
  //   },
  // },
];

export const columns = _columns.map((col) => {
  if (col.sorter) {
    return {
      ...col,
      sortIcon: ({ sortOrder }) => {
        return (
          <Flex vertical>
            <TbChevronUp className={`-mb-1 ${sortOrder === "ascend" ? "stroke-brand-500" : "stroke-neutral-400"}`} />
            <TbChevronDown className={`-mt-1 ${sortOrder === "descend" ? "stroke-brand-500" : "stroke-neutral-400"}`} />
          </Flex>
        );
      },
    };
  } else if (col.filters) {
    return {
      ...col,
      filterIcon: (filtered) => (filtered ? <TbFilterFilled /> : <TbFilterFilled />),
    };
  } else return col;
}) satisfies ColumnsType<PopulatedLeadDto>;
